import React from "react"
import { findDOMNode as findSlateDOMNode } from "@convertkit/slate-react"
import Keymap from "./keymap"

const MIN_FONT_SIZE = 1
const MAX_FONT_SIZE = 100

export default () => [
  {
    commands: {
      setFontSize: (editor, fontSize) => {
        editor.removeFontSize()
        editor.addMark({ type: "font-size", data: { fontSize } })
      },
      removeFontSize: editor => {
        editor.value.marks
          .filter(mark => mark.type == "font-size")
          .map(mark => editor.removeMark(mark))
      },
      increaseFontSize: editor => {
        const fontSize = editor.getFontSize()
        editor.setFontSize(Math.min(fontSize + 1, MAX_FONT_SIZE))
      },
      decreaseFontSize: editor => {
        const fontSize = editor.getFontSize()
        editor.setFontSize(Math.max(fontSize - 1, MIN_FONT_SIZE))
      }
    },
    queries: {
      getFontSize(editor) {
        const fontSizeMark = editor.value.marks.find(
          mark => mark.type === "font-size"
        )
        // The font size is set by our editor, so return that
        if (fontSizeMark) return fontSizeMark.data.get("fontSize")

        // Otherwise, the font size is determined by the current
        // styles on the page.
        const block = editor.value.focusBlock
        const node = findSlateDOMNode(block)
        const fontSize = parseInt(window.getComputedStyle(node).fontSize)
        return fontSize
      }
    },
    renderMark(props, editor, next) {
      const { attributes, children, mark } = props

      switch (mark.type) {
        case "font-size":
          return (
            <span
              {...attributes}
              style={{ fontSize: `${mark.data.get("fontSize")}px` }}
            >
              {children}
            </span>
          )
        default:
          return next()
      }
    }
  },
  // For the keyboard combination `mod+shift+>`, the browser's
  // `event.key` is equal to ".". Because of this, we aren't sure
  // how this would work for keyboards where the ">" and "." are
  // separate keys. See https://github.com/ConvertKit/convertkit/issues/10115.
  Keymap({
    // mod+shift+>
    "mod+shift+.": "increaseFontSize",
    // mod+shift+<
    "mod+shift+,": "decreaseFontSize"
  })
]
